import { useQuery } from "@apollo/client/react";
import { tr } from 'react-hook-form-auto'

import { Place } from '../../models/place'
import { FlexList } from '../../components/FlexList'
import { IngredientTagFlex } from '../ingredients/IngredientTagFlex'

import styles from './PlaceIngredients.sass'

export const PlaceIngredientsContainer = ({ placeId }) => {
  const { data } = useQuery(Place.fetchIngredients, {
    variables: { placeId },
    skip: !placeId
  })
  const collection = data && data.collection || []

  if (data && collection.length == 0)
    return (
      <div className={styles.empty}>
        {tr('models.place.noIngredients')}
      </div>
    )

  return (
    <FlexList>
      {collection.map(ingredient =>
        <IngredientTagFlex key={ingredient.id} doc={ingredient} />
      )}
    </FlexList>
  )
}
